import React from "react";
import Icon from "./Icon";

const WorkflowFigure = ({ step, index, onOpen, extra = false, showArrow = false }) => (
    <article
        className={`clk-workflow-step clk-workflow-step--${step.accent}${extra ? " clk-workflow-step--extra" : ""} clk-reveal d${(index % 6) + 1}`}
    >
        <button
            type="button"
            className="clk-workflow-shot"
            onClick={() => onOpen(step)}
            aria-label={`View step ${step.n}: ${step.t}`}
        >
            <span className="clk-workflow-shot-frame">
                <span className="clk-workflow-shot-screen">
                    <img
                        src={step.image}
                        alt=""
                        className="clk-workflow-shot-img"
                        loading="lazy"
                        decoding="async"
                    />
                </span>
                <span className="clk-workflow-shot-zoom" aria-hidden="true">
                    <Icon name="search" size={16} />
                    <span>View full size</span>
                </span>
            </span>
        </button>

        <div className="clk-workflow-step-body">
            {extra ? (
                <span className="clk-workflow-step-optional-tag">Optional</span>
            ) : (
                <span className="clk-workflow-step-num">{step.n}</span>
            )}
            <div className="clk-workflow-step-copy">
                <h3>{step.t}</h3>
                <p>{step.d}</p>
            </div>
        </div>

        {showArrow && (
            <span className="clk-workflow-step-arrow" aria-hidden="true">
                <Icon name="arrow" size={14} />
            </span>
        )}
    </article>
);

export default WorkflowFigure;
